<template>
  <div>
    <el-dialog
      :title="agentBackendData.title"
      :visible.sync="agentBackendData.show"
      width="650px"
      center
    >
      <el-form inline :model="editForm" label-width="130px">
        <el-form-item :label="$t('AgentID')">
          <el-input
            disabled
            style="width: 350px"
            v-model="editForm.UserId"
            :placeholder="$t('AgentID')"
          ></el-input>
        </el-form-item>
        <el-form-item label="代理绑定域名">
          <el-input
            disabled
            style="width: 350px"
            v-model="editForm.Host"
            placeholder="代理绑定域名"
          ></el-input>
        </el-form-item>
        <el-form-item label="代理后台账号">
          <el-input
            clearable
            style="width: 350px"
            v-model="editForm.Account"
            placeholder="代理后台账号"
          >
            <template slot="append">
              <el-tooltip
                content="登录代理后台时，账号需加上代理ID，格式为“ID_账号”。例如，此处账号为：admin，代理ID为：44999852，则登录名为：44999852_admin。"
                placement="top"
              >
                <el-button icon="el-icon-question" type="primary"></el-button>
              </el-tooltip> </template
          ></el-input>
        </el-form-item>
        <el-form-item label="代理后台密码">
          <el-input
            clearable
            type="password"
            style="width: 350px"
            v-model="editForm.Password"
            placeholder="代理后台密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="代理后台谷歌密钥">
          <el-input
            clearable
            style="width: 300px"
            v-model="editForm.GoogleSecret"
            placeholder="代理后台谷歌密钥"
          ></el-input>
          <el-button
            style="margin-left: 10px"
            @click="resetStr"
            type="primary"
            size="mini"
            >{{$t('Reset')}}</el-button
          >
          <el-button
            style="margin-left: 10px"
            @click="showQR"
            type="primary"
            size="mini"
            >二维码</el-button
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click="submitEditRow"
          >{{ $t('Confirm') }}</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="二维码" :visible.sync="show" width="250px" center>
      <div ref="qrCodeUrl"></div>
    </el-dialog>
  </div>
</template>

<script>
import { app } from "@/api/app.js";
import QRCode from "qrcodejs2";
export default {
  props: {
    agentBackendData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      editForm: {
        Host: "",
        UserId: "",
        Account: "",
        Password: "",
        GoogleSecret: "",
      },
      show: false,
      url: "",
      mLastPassword: "",
    };
  },
  created() {
    this.editForm.Host = this.agentBackendData.rowData.Host;
    this.editForm.UserId = this.agentBackendData.rowData.UserId;
    if (this.agentBackendData.rowData.BackOffaceInfo) {
      let data = JSON.parse(this.agentBackendData.rowData.BackOffaceInfo);
      this.editForm.GoogleSecret = data.GoogleSecret;
      this.editForm.Account = data.Account;
      this.editForm.Password = data.Password;
    } else {
      this.editForm.GoogleSecret = this.getStr();
    }
    this.mLastPassword = this.editForm.Password;
    // if (!this.editForm.Account && !this.editForm.Password) {
    //   this.OnReqGetAccount();
    // }
  },
  methods: {
    OnReqGetAccount() {
      // let tData = {
      //   SellerId: this.agentBackendData.rowData.SellerId,
      //   Id: this.agentBackendData.rowData.Id,
      // };
      // app.post("/agent/get_agent_admin_user", tData, (rest) => {
      //   if (rest.code == 200) {
      //     this.editForm.Account = rest.data.Account;
      //     this.editForm.Password = rest.data.Password;
      //   }
      // });
    },
    showQR() {
      if (!this.editForm.Account)
        return this.$message.error("请输入代理后台账号");
      this.url = `otpauth://totp/98代理:${this.editForm.Account}?algorithm=SHA1&digits=6&issuer=98代理&period=30&secret=${this.editForm.GoogleSecret}`;
      this.show = true;
      this.$nextTick(() => {
        this.$refs.qrCodeUrl.innerHTML = "";
        new QRCode(this.$refs.qrCodeUrl, {
          text: encodeURI(this.url),
          width: 200,
          height: 200,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
      });
    },
    resetStr() {
      this.editForm.GoogleSecret = this.getStr();
    },
    getStr(length = 32) {
      let arr = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ];
      let num = "";
      for (let index = 0; index < length; index++) {
        num += arr[parseInt(Math.random() * 26)];
      }
      return num;
    },
    submitEditRow() {
      let data = {
        Account: this.editForm.Account,
        GoogleSecret: this.editForm.GoogleSecret,
      };
      if (this.mLastPassword == this.editForm.Password) {
        data.Password = this.editForm.Password;
      } else {
        data.Password = this.$md5(this.editForm.Password); // 有改动，才加密
      }
      this.agentBackendData.rowData.BackOffaceInfo = JSON.stringify(data);
      this.$emit("submitAgentBackendData", this.agentBackendData.rowData);
    },
  },
};
</script>
